import React from 'react';
import PropTypes from 'prop-types';
import {NeuroMessage, TransitionContainer} from "@ignitesales/neuro-application";
import classnames from "classnames";
import {useDialogueContext} from "../hooks/useDialogueContext.mjs";

const SurveyPagePathMessage = ({ className, tagName = 'h4'}) => {
    const { getPagePathMessageId } = useDialogueContext();
    const messageId = getPagePathMessageId();
    const classes = classnames('pagePathMessageContainer', className);

    return <TransitionContainer className={classes} transitionKey={messageId}>
        <NeuroMessage className='pagePathMessage' id={messageId} tagName={tagName} shouldHideIfNotFound={true} />
    </TransitionContainer>
};

SurveyPagePathMessage.propTypes = {
    className: PropTypes.string,
    tagName: PropTypes.string
};

export default SurveyPagePathMessage;
